import AboutPage from "./AboutPage";
import "./about-page.scss";

export default AboutPage;
